import { render, staticRenderFns } from "./YSDPrintModel.vue?vue&type=template&id=1bc80bfe&scoped=true"
import script from "./YSDPrintModel.vue?vue&type=script&lang=js"
export * from "./YSDPrintModel.vue?vue&type=script&lang=js"
import style0 from "./YSDPrintModel.vue?vue&type=style&index=0&id=1bc80bfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc80bfe",
  null
  
)

export default component.exports